import React from "react";
import { S3ProviderListOutputItem } from "@aws-amplify/storage";
import { Card, Flex, Heading, Image } from "@aws-amplify/ui-react";

const openLink = (url : string | undefined) => {
  if (url == undefined) return
  window.open(url, "_blank", "noopener,noreferrer")
}

export function ImageCard({
  item,
  index,
  imageKeys
}: {
  index: number;
  item: string;
  imageKeys: S3ProviderListOutputItem[];
}) {
  return (
    <button 
      onClick={(e) => {openLink(imageKeys[index]?.key?.replace(/thumbnail_/g, ""))}}
      style={{ border: "none", all: "unset" }}
    >
      <Card lineHeight="small" border={"1px solid lightgrey"}>
        <Flex gap="xxs" direction="column">
          <Image
            alt={imageKeys[index]?.key}
            width="300"
            height="300"
            src={item}
            sizes="50vw"
            style={{ borderRadius: "medium", objectFit: "contain", cursor: "pointer" }}
          ></Image>
          <Flex alignItems="center">
            <Heading level={2} isTruncated={true}>
              {imageKeys[index]?.key}
            </Heading>
          </Flex>
        </Flex>
      </Card>
    </button>
    
  );
}

export function ImageCardName({
  imgSrc,
  index,
  imageKeys,
  thumbnails
}: {
  index: number;
  imgSrc: string;
  imageKeys: string[];
  thumbnails: string[];
}) {
  return (
    <Card lineHeight="small" border={"1px solid lightgrey"}>
      <Flex gap="xxs" direction="column">
        <Image
          alt={imageKeys[index]}
          width="300"
          height="300"
          src={thumbnails[index]}
          sizes="50vw"
          style={{ borderRadius: "medium", objectFit: "contain", cursor: "pointer" }}
          onClick={(e) => {openLink(imgSrc)}}
        ></Image>
        <Flex alignItems="center">
          <Heading level={2} isTruncated={true}>
            {imageKeys[index]}
          </Heading>
        </Flex>
      </Flex>
    </Card>
  );
}
